import { gql } from '@apollo/client'

const DEFAULT_LIMIT = 7305 // 5 years total, 4 records daily

export const getHashpriceHistory = gql`
  query getHashpriceHistory($limit: Int = ${DEFAULT_LIMIT}, $filter: GetHashpriceRecordFilter) {
    getHashprice(first: $limit, filter: $filter) {
      totalCount
      nodes {
        priceDate
        priceUsd
        priceBtc
      }
    }
  }
`
